#import "./fragments/aiChatFragments.graphql"
#import "./fragments/aiChatDiagnosticsFragments.graphql"

query getTranscriptList($min: String, $max: String) {
  result: getTranscriptList(min: $min, max: $max) {
    content
    success
  }
}

query getAIChats {
  chats: getAIChats {
    id
    title
    createdAt
    updatedAt
  }
}

query getAIChatById($id: String!) {
  chat: getAIChatById(id: $id) {
    id
    title
    createdAt
    updatedAt
    messages {
      ...AIChatMessageFragment
    }
  }
}

query findAIChatById($id: String!) {
  chat: findAIChatById(id: $id) {
    id
    participantId
    userChatId
    title
    createdAt
    updatedAt
    messages {
      ...AIChatSupportDiagnosticsFragment
    }
    subAgentChats {
      id
      userChatId
      title
      createdAt
      updatedAt
      messages {
        ...AIChatSupportDiagnosticsFragment
      }
    }
  }
}

query getAIChatTrace($chatId: ID!) {
  trace: getAIChatTrace(chatId: $chatId) {
    chatId
    traceIds
    spans {
      id
      traceId
      spanId
      parentSpanId
      chatId
      messageId
      source
      kind
      name
      status
      startedAt
      endedAt
      durationMs
      firstEventMs
      firstVisibleOutputMs
      attributes
      error
    }
  }
}

query getAIDashboards {
  dashboards: getAIDashboards {
    id
    title
    aiChatId
    createdAt
    updatedAt
    format
  }
}

query getAIDashboardById($id: String!, $version: String) {
  dashboard: getAIDashboardById(id: $id, version: $version) {
    id
    title
    aiChatId
    createdAt
    updatedAt
    content
    versionNumber
    latestVersionNumber
    lastPublishedVersionNumber
    lastPublishedAt
    css
    template
    queries
    queriesJson
    variables
    plan
    transforms
    charts
    filters
  }
}

query hydrateDashboard($input: HydrateDashboardInput!) {
  hydrateDashboard(input: $input) {
    state
    charts
    errors {
      scope
      key
      code
      message
    }
    queryStatus
    queryData
    debug
  }
}

query getAISummaries($searchTerm: String, $limit: Int, $offset: Int) {
  getAISummaries(searchTerm: $searchTerm, limit: $limit, offset: $offset) {
    summaries {
      id
      entityType
      entityId
      status
      error
      createdAt
      updatedAt
      lastRefreshedAt
    }
    total
  }
}

query searchAIChats($searchTerm: String, $limit: Int, $offset: Int) {
  searchAIChats(searchTerm: $searchTerm, limit: $limit, offset: $offset) {
    chats {
      id
      participantId
      title
      createdAt
      updatedAt
    }
    total
  }
}

query getAISummaryById($id: String!) {
  getAISummaryById(id: $id) {
    id
    entityType
    entityId
    systemPrompt
    userPrompt
    content
    citations
    lastRefreshedAt
    status
    error
    createdAt
    updatedAt
  }
}
